<!-- 商城首页 -->
<template>
  <div id="home" class="home" name="home">

    <!-- 轮播图 -->
    <div class="block">
      <!-- 背景模板颜色 -->
      <div id="home-mask" :style="'background-color:' + maskBack" />
      <el-container>
        <el-aside width="246px" />
        <el-container>
          <el-container>
            <div class="swiper">
              <el-carousel height="481px" style="width: 728px" @change="carouselChange">
                <el-carousel-item v-for="(item, index) in plateData.carouselimgs" :key="index">
                  <img style="cursor: pointer" :src="item.FImagePath" alt="" @click="advertisement(item)">
                </el-carousel-item>
              </el-carousel>
            </div>
            <el-aside width="245px" style="background:#fff;z-index:9;margin-top: -1px;border-top: 1px #eee solid;">
              <div class="rightHi">
                <!-- 头像和昵称部分 -->
                <div class="Identification">
                  <div class="head-box">
                    <div class="head">
                      <img v-if="name" src="@/assets/images/loginHead.png" height="53" width="53" alt>
                      <img v-else src="@/assets/images/notLoginHead@2x.png" height="53" width="53" alt>
                    </div>
                    <div class="account">
                      <div class="nikname">{{ name ? name : "Hi,您好!" }}</div>
                      <div v-if="name" class="welcome">{{ DemandDepartName||'' }}</div>
                      <div v-else class="welcome">欢迎光临实达实</div>
                      <div v-if="name" class="bgClass">
                        <!-- <div class="userInf">
                          <p>{{ this.$store.state.user.customer.name }}</p>
                          <p class="userPho" style="font-size:15px;">
                            {{ this.$store.state.user.customer.pho }}
                          </p>
                        </div> -->
                        <!-- <svg-icon class="classSvg" icon-class="bgindex" /> -->
                        <!-- <img src="../../../assets/images/bgindex.png" alt="" /> -->

                      </div>
                    </div>

                  </div>
                  <div v-if="name" class="user-card">
                    <div class="user-card-left">
                      <span>
                        专属
                        <br>
                        客服
                      </span>
                    </div>
                    <div class="user-card-right" style="white-space:nowrap;">
                      {{ $store.state.user | userPhone }}
                    </div>
                  </div>
                  <!-- <div v-if="name" class="loginButton">
                    <div @click="goshop()">
                      <svg-icon icon-class="zaixianTopup" />
                      我的订单
                    </div>
                    <div @click="logout">
                      <svg-icon icon-class="order" />
                      退出登录
                    </div>
                    <div>
                            账期权益
                          </div>
                          <div>
                            优惠券
                          </div>
                  </div> -->
                  <div v-if="!name" class="goLogin">
                    <div class="signIn signlog-box">
                      <div class="signIn" @click="$router.push({ path: '/login/register' })">
                        <!-- @mousemove="loginMove(1)"
                              @mouseleave="loginLeave()" -->
                        免费注册
                        <div v-if="isLogin === 1" class="login-box">
                          <div class="loginId registeLogin">
                            <div class="login-up" />
                            <div class="button" @mousemove="loginButtomMove(2)" @mouseleave="loginButtonLeave()">
                              <svg-icon v-if="isLoginButton !== 2" icon-class="gongying-black" />
                              <svg-icon v-if="isLoginButton === 2" icon-class="gongying-red" />
                              <a
                                :href="path + 'register'"
                                target="_blank"
                                :class="isLoginButton == 2 ? 'buttonRed' : ''"
                              >我要供应</a>
                            </div>
                            <div class="button" @mousemove="loginButtomMove(4)" @mouseleave="loginButtonLeave()">
                              <svg-icon v-if="isLoginButton !== 4" icon-class="caigou-black" />
                              <svg-icon v-if="isLoginButton === 4" icon-class="caigou-red" />
                              <router-link
                                :class="isLoginButton == 4 ? 'buttonRed' : ''"
                                :to="{ path: '/login/register' }"
                              >我要采购</router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="logIn">
                        <!-- @click="$router.push({path: '/login/login'})" -->
                        <!-- @mousemove="loginMove(2)"
                              @mouseleave="loginLeave()" -->
                        <!-- 请登录 -->
                        <router-link to="/login/login">请登录</router-link>
                        <div v-if="isLogin === 2" class="login-box">
                          <div class="loginId">
                            <div class="login-up" />
                            <div class="button" @mousemove="loginButtomMove(1)" @mouseleave="loginButtonLeave()">
                              <svg-icon v-if="isLoginButton !== 1" icon-class="gongying-black" />
                              <svg-icon v-if="isLoginButton === 1" icon-class="gongying-red" />
                              <a
                                :href="path + 'login'"
                                target="_blank"
                                :class="isLoginButton == 1 ? 'buttonRed' : ''"
                              >我要供应</a>
                            </div>
                            <div class="button" @mousemove="loginButtomMove(3)" @mouseleave="loginButtonLeave()">
                              <svg-icon v-if="isLoginButton !== 3" icon-class="caigou-black" />
                              <svg-icon v-if="isLoginButton === 3" icon-class="caigou-red" />
                              <router-link
                                :class="isLoginButton == 3 ? 'buttonRed' : ''"
                                :to="{ path: '/login/login' }"
                              >我要采购</router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 跳转列表 -->
                <div class="link-list">
                  <div>
                    <div class="link-list-li" @click="tagUse(1)">
                      <svg-icon icon-class="home-1" />
                      <span>订单管理</span>
                      <span v-show="comput.FWRQuanty&&comput.FWRQuanty!=0" class="fizz">{{ comput.FWRQuanty | maxwting }}</span>
                    </div>
                  </div>
                  <div>
                    <div class="link-list-li" @click="tagUse(2)">
                      <svg-icon icon-class="home-2" />
                      <span>审批管理</span>
                      <span v-show="comput.FWAQuanty&&comput.FWAQuanty!=0" class="fizz">{{ comput.FWAQuanty | maxwting }}</span>
                    </div>
                  </div>
                  <div>
                    <div class="link-list-li" @click="tagUse(3)">
                      <svg-icon icon-class="home-3" />
                      <span>收藏商品</span>
                    </div>
                  </div>
                  <div>
                    <div class="link-list-li" @click="tagUse(4)">
                      <svg-icon icon-class="home-4" />
                      <span>我的账单</span>
                    </div>
                  </div>
                  <div>
                    <div class="link-list-li" @click="tagUse(5)">
                      <svg-icon icon-class="home-5" />
                      <span>我的钱包</span>
                    </div>
                  </div>
                  <div v-if="name">
                    <div class="link-list-li" @click="logout">
                      <svg-icon icon-class="home-6" />
                      <span>退出登录</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-aside>
          </el-container>
          <!-- <el-footer height="94px" style="margin: 8px 0 0 12px">
                  <ul class="poster">
                    <li
                      v-for="(item, index) in plateData.adposition"
                      :key="index"
                      @click="advertisement(item)"
                    >
                      <img :src="item.FImagePath" height="94" alt>
                    </li>
                  </ul>
                </el-footer> -->
        </el-container>
      </el-container>
    </div>
    <!-- 轮播图END -->
    <div class="main-box">
      <div class="main">
        <!-- 精品推荐区域 -->
        <div class="goodsTitle">
          <svg-icon icon-class="slash" />
          <div>品牌专区</div>
          <svg-icon icon-class="slash" />
          <!-- 新增 -->
        </div>
        <ul class="brankZone">
          <li v-for="(t,i) in brankList" :key="i" class="brankInfo" @click="toSearch(t)">
            <div class="brankName">
              <img v-if="t.FCover" :src="t.FCover" alt="">
              <span v-else>
                {{ t.FName }}
              </span>
            </div>
          </li>
        </ul>
        <div class="goodsTitle">
          <svg-icon icon-class="slash" />
          <div>热销商品</div>
          <svg-icon icon-class="slash" />
          <!-- 新增 -->
        </div>
        <ul class="stockSort">
          <li
            v-for="(t, i) in dataList"
            :key="i"
            :class="activeName == t.FTreeCode ? 'sortInfo selectSort' : 'sortInfo'"
            @click="sortChange(t.FTreeCode)"
          >
            {{ t.FName }}
          </li>
        </ul>
        <div class="shopping">
          <div class="box-bd">
            <div class="promo-list">
              <MyList :list="itemRecommend" :is-more="true" />
              <el-empty v-if="!itemRecommend.length" description="暂无商品" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div style="display:none;">
            <a href="https://www.ttkefu.com">
              在线客服系统
            </a>
          </div> -->
  </div>
</template>

<script>
// import 'https://w102.ttkefu.com/k/?fid=4H7HC6'
import path from '@/utils/path.js'
import { mapGetters } from 'vuex'
import quest from '@/views/manageMent/api/user'
import { getUser } from '@/api/home'
import request from '@/utils/request.js'
import {
  getFRecommendList,
  getStockClass,
  getIndexShopDecoration,
  getRecommendData
} from '@/api/home'
export default {
  data() {
    return {
      comput: {
        FWRQuanty: 0, // 待收货订单数量
        FWAQuanty: 0 // 待审批订单数量
      },
      activeName: '',
      maskBack: '',
      user: {
        name: '',
        pho: ''
      },
      path,
      isLogin: '', // 鼠标移入去登陆时候得弹窗
      isregisteLogin: false, // 鼠标移入免费注册
      isLoginButton: '', // 鼠标移入切换icon
      activeIndex: '1', // 精品推荐导航栏默认
      carousel: '', // 轮播图数据
      // loginginStatus: true, // 登录状态
      shopList: [],
      valdata: [],
      dataList: [],
      plateData: [],
      itemRecommend: [],
      pageNo: 1,
      pageSize: 15,
      isMore: true,
      loading: false,
      routePush: {},
      stockClassList: [], // 商品分类的list
      // phoneList: '', // 手机商品列表
      // miTvList: '', // 小米电视商品列表
      // applianceList: '', // 家电商品列表
      // applianceHotList: '', // 热门家电商品列表
      // accessoryList: '', // 配件商品列表
      // accessoryHotList: '', // 热门配件商品列表
      // protectingShellList: '', // 保护套商品列表
      // chargerList: '', // 充电器商品列表
      // applianceActive: 1, // 家电当前选中的商品分类
      // accessoryActive: 1 // 配件当前选中的商品分类
      brankList: [],
      sortList: []
    }
  },
  computed: {
    ...mapGetters(['name', 'customer', 'DemandDepartName']),
    routes() {
      const settingRoute = this.routeGather.filter(item => !item.hidden).map(items => items.meta.title)
      return function(val) {
        return settingRoute.indexOf(val) > -1
      }
    }
  },
  filters: {
    userPhone(val = {}) {
      if (val.customer) {
        let leftstr = ''; let rightstr = ''
        if (val.customer.name) {
          leftstr = val.customer.name + ' '
        }
        if (val.customer.pho) {
          const str = String(val.customer.pho)
          rightstr = str.slice(0, 3) + ' ' + str.slice(3, 7) + ' ' + str.slice(7)
        }
        return leftstr + rightstr
      } else {
        return ''
      }
    },
    maxwting(num) {
      if (isNaN(Number(num))) return '0'
      if (Number(num) > 99) return '99+'
      return num
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.routePush = from
    })
  },
  watch: {
    // $route: {
    //   immediate: true, // 一旦监听到路由的变化立即执行
    //   handler(to, from) {
    //     console.log(to, from);
    //     this.routePush = from;
    //     if (from == undefined) {
    //       return;
    //     }
    //   },
    // },
    // 家电当前选中的商品分类，响应不同的商品数据
    applianceActive: function(val) {
      // 页面初始化的时候把applianceHotList(热门家电商品列表)直接赋值给applianceList(家电商品列表)
      // 所以在切换商品列表时判断applianceHotList是否为空,为空则是第一次切换,把applianceList赋值给applianceHotList
      if (this.applianceHotList === '') {
        this.applianceHotList = this.applianceList
      }
      if (val === 1) {
        // 1为热门商品
        this.applianceList = this.applianceHotList
        return
      }
      if (val === 2) {
        // 2为电视商品
        this.applianceList = this.miTvList
        return
      }
    },
    accessoryActive: function(val) {
      // 页面初始化的时候把accessoryHotList(热门配件商品列表)直接赋值给accessoryList(配件商品列表)
      // 所以在切换商品列表时判断accessoryHotList是否为空,为空则是第一次切换,把accessoryList赋值给accessoryHotList
      if (this.accessoryHotList === '') {
        this.accessoryHotList = this.accessoryList
      }
      if (val === 1) {
        // 1为热门商品
        this.accessoryList = this.accessoryHotList
        return
      }
      if (val === 2) {
        // 2为保护套商品
        this.accessoryList = this.protectingShellList
        return
      }
      if (val === 3) {
        // 3 为充电器商品
        this.accessoryList = this.chargerList
        return
      }
    }
  },
  /**
   * keep-alive生命周期调用时，改变全局背景颜色
   */
  activated() {
    document
      .getElementById('shopApp')
      .setAttribute('style', 'background-color:#F5F5F5;')
    // 进入首页时给store的router里面设置当前页面路径
    this.$store.commit('app/SET_ROUTER', '/Home')
  },
  /**
   * keep-alive生命周期取消掉用，取消改变背景颜色
   */
  deactivated() {
    document.getElementById('shopApp').removeAttribute('style')
    // 离开时变成‘’
    this.$store.commit('app/SET_ROUTER', '')
  },
  created() {
    if (localStorage.getItem('userInfo') == undefined || !document.cookie) {
      if (!localStorage.getItem('userInfo')) {
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
        if (keys) {
          for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
        }
      }
      if (!document.cookie) {
        this.$store.commit('user/SET_NAME', '')
        this.$store.commit('user/SET_COMPANY', '')
        this.$store.commit('user/CUSTOMER', '')
        sessionStorage.removeItem('vuex')
        localStorage.removeItem('userInfo')
      }
    } else {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.$store.commit('user/SET_NAME', userInfo.fuserName)
      const company = `${userInfo.fuserName}--${userInfo.funitName}`
      this.$store.commit('user/SET_COMPANY', company)
    }
    // this.itemDataId()
    this.getLogo()
    this.getBrankSortList()
  },
  mounted() {
    window.addEventListener('scroll', this.lazyLoading) // 滚动到底部，再加载的处理事件
    this.getCustomer()
    this.getComput()
  },
  destroyed() {
    window.removeEventListener('scroll', this.lazyLoading)
  },
  methods: {
    getComput() {
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo) {
        const userInfoj = JSON.parse(userInfo)
        // console.log(userInfoj)
        if (userInfoj.fuserId) {
          quest.fszzInfo(userInfoj.fuserId).then(res => {
            this.comput = res.data || {}
          })
        }
      }
    },
    toSearch(t) {
      var Time = new Date().getTime()
      this.$router.replace({
        path: '/search/searchPage',
        query: { search: '', Time, markID: t.FID, markName: t.FName }
      })
    },
    tagUse(val) {
      if (!this.name) return this.$router.push('/login/login')
      let tag = ''
      switch (val) {
        case 1:
          tag = '/order/orderManagement'

          break
        case 2:
          tag = '/approvalQuery/approvalQuery'

          break
        case 3:
          tag = '/merchandise/merchandise'
          break
        case 4:
          tag = '/statement/statement'
          break
        case 5:
          tag = '/wallet/wallet'
          break
      }
      if (tag) {
        this.$router.push(tag)
      }
    },
    getBrankSortList() {
      const userInfo = localStorage.getItem('userInfo')
      const fDemandUnitId = userInfo ? JSON.parse(userInfo).funitID : 0
      const params = new URLSearchParams()
      params.append('fDemandUnitId', fDemandUnitId)
      request({
        url: '/mall/mallmanage/index/getSellWellMark',
        method: 'post',
        params
      })
        .then(res => {
          if (res.result) {
            this.brankList = res.data
          }
        })
      request({
        url: '/mall/mallmanage/index/getSellWellClass',
        method: 'post',
        params
      })
        .then(res => {
          if (res.result) {
            this.dataList = res.data
            this.activeName = this.dataList[0].FTreeCode
            this.getRecommend(res.data[0].FTreeCode)
          }
        })
    },
    carouselChange(val) {
      this.maskBack = this.plateData.carouselimgs[val].FBackcolor || 'transparent'
    },
    getCustomer() {
      const data = JSON.parse(localStorage.getItem('userInfo'))
      if (data) {
        getUser().then((res) => {
          this.user.name = res.data.FName
          this.user.pho = res.data.FPhoneNo
          this.$store.commit('user/CUSTOMER', this.user)
        })
      }
    },
    goshop() {
      this.$router.push({
        path: '/order/orderManagement'
      })
    },
    logout() {
      //   const e = this.$parent.$parent.$children[0]
      this.$confirm('您确定要退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 清空本地登录信息
          localStorage.removeItem('userInfo')
          // localStorage.setItem('user', '')
          localStorage.removeItem('userInfo')
          const e = this.$parent.$parent.$children[0]
          e.showName = ''
          e.showTitle = false
          e.company = false
          this.$store.commit('user/SET_NAME', '')
          this.$store.commit('user/SET_TOKEN', '')
          this.$store.commit('user/SET_COMPANY', '')
          var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
          if (keys) {
            for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
          }
          this.$store.commit('user/CUSTOMER', '')
          sessionStorage.removeItem('vuex')
          sessionStorage.removeItem('company')
          // 清空vuex登录信息
          // this.setUser('')

          if (this.$route.name == 'Home') {
            this.$parent.$parent.$parent.getLogo()
          }
          this.notifySucceed('成功退出登录')
          this.$router.push({ path: '/Home' })
          this.$message({
            type: 'success',
            message: '成功退出登录!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出登录'
          })
        })
    },
    advertisement(item) {
      if (!localStorage.getItem('userInfo')) {
        this.$router.push({ path: '/login/login' })
        return
      }
      if (!item.FUrl) return
      window.open(item.FUrl)
    },
    swiperClick(item) {
      if (!localStorage.getItem('userInfo')) {
        this.$router.push({ path: '/login/login' })
        return
      }
      if (!item.FUrl) return
      window.open(item.FUrl)
      //   if (!item.FShopId) return
      //   this.$router.push({
      //     path: '/store',
      //     query: {
      //       shopid: item.FShopId
      //     }
      //   })
      //   quest.MallStoreNavigation(item.FShopId).then(res => {
      //     const data = res.data.find(item => item.fnavigationName == '店铺档案') || {}
      //     this.$router.push({
      //       path: '/store/storeFile',
      //       query: {
      //         mallstorestockFId: item.FShopId,
      //         forder: data.forder,
      //         storeId: item.FShopId,
      //         fid: data.fid,
      //         name: '店铺档案'
      //       }
      //     })
      //   })
      //   window.open(item.FUrl, '_blank')
    },
    itemDataId() {
      const url = (localStorage.getItem('userInfo') && document.cookie)
        ? '/mall/mallmanage/index/getFRecommendTypesLogin'
        : '/mall/mallmanage/index/getFRecommendTypes'
      request({
        url,
        method: 'post'
      })
        .then((res) => {
          if (res.rows.length > 0) {
            this.dataList = res.rows
            if (this.dataList.length) {
              this.activeName = this.dataList[0].FID
              this.getRecommend(res.rows[0].FID)
            }
            // this.valdata = this.dataList.length
          }
        })

      //   getRecommendData().then((res) => {
      //     if (res.rows.length > 0) {
      //       this.dataList = res.rows
      //       this.valdata = this.dataList.length
      //       this.getRecommend(res.rows[0])
      //     }
      //   })
    },
    // activeName
    lazyLoading() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      const h = document.getElementsByClassName('el-footer')[0].clientHeight + 460
      const search = scrollHeight - (scrollTop + clientHeight) < h
      if (scrollHeight > clientHeight &&
        search &&
        this.itemRecommend.length >= 15 &&
        this.isMore &&
        !this.loading) {
        this.getRecommend(this.activeName)
      }
    },
    sortChange(val) {
      this.activeName = val
      this.itemRecommend = []
      this.isMore = true
      this.getRecommend(val)
    },
    // 获取点击后的数据
    getRecommend(FTreeCode) {
      let FShowAllStock
      this.$parent.$parent.$parent.$refs.headerSearch && (FShowAllStock = Number(!this.$parent.$parent.$parent.$refs.headerSearch.isShoping))
      this.loading = true
      this.pageNo = Math.floor(this.itemRecommend.length / 15) + 1
      const params = new URLSearchParams()
      const jsonobj = {
        FTreeCode,
        PageNo: this.pageNo,
        PageSize: this.pageSize,
        FSearchType: FShowAllStock
      }
      params.append('jsonobj', JSON.stringify(jsonobj))
      const url = (localStorage.getItem('userInfo') && document.cookie)
        ? '/mall/mallmanage/index/getSellWellStockLogin'
        : '/mall/mallmanage/index/getSellWellStockNotLogin'
      request({
        url,
        method: 'post',
        params
      })
        .then((res) => {
        //   res.data.records && res.data.records.map(t => {
        //     t.FShortCode = t.FShortCode ? t.FShortCode.slice(0, 9) : ''
        //   })
          if (!res.data.records || res.data.records.length < 15) {
            this.isMore = false
          }
          if (res.data.records) {
            this.itemRecommend = this.itemRecommend.concat(res.data.records)
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
        .catch(() => {
          this.loading = false
        })
      //   getFRecommendList({ fmasterID: item.FID }).then((res) => {
      //     this.itemRecommend = res.rows
      //   })
    },

    loginMove(index) {
      this.isLogin = index
    },
    loginLeave() {
      this.isLogin = ''
    },
    loginButtomMove(index) {
      this.isLoginButton = index
    },
    loginButtonLeave() {
      this.isLoginButton = ''
    },
    registerMove() {
      this.isregisteLogin = true
    },
    registerLeave() {
      this.isregisteLogin = false
    },
    // 获取家电模块子组件传过来的数据
    getChildMsg(val) {
      this.applianceActive = val
    },
    // 获取配件模块子组件传过来的数据
    getChildMsg2(val) {
      this.accessoryActive = val
    },
    // 获取各类商品数据方法封装
    getPromo(categoryName, val, api) { },
    // 点击了导航菜单
    handleSelect(key, keyPath) { },

    // 获取商品分类信息
    async getStockClass() {
      const res = await getStockClass()
      this.stockClassList = res.rows
    },
    getLogo() {
      getIndexShopDecoration({ modelID: 1 }).then((res) => {
        this.plateData = res
        this.$nextTick(() => {
          this.carouselChange(0)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/shopIndex.scss";

#home {
  .el-footer {
    padding: 0;
  }
}
</style>
<style lang='scss'>
#home {
    .goodsTitle {
        font-weight: bold;
    }
  .main-box {
      .stockSort {
          display: flex;
          flex-wrap: wrap;
          margin-top: 15px;
          .sortInfo {
              cursor: pointer;
              caret-color: rgba(0,0,0,0);
              width: 120px;
              height: 38px;
              line-height: 38px;
              border: 1px solid #DBDBDB;
              border-radius: 4px;
              background: #fff;
              text-align: center;
              font-size: 14px;
              color: #333;
              overflow: hidden;
              margin-right: 17.5px;
              margin-bottom: 16px;
          }
          .sortInfo:nth-child(9n+9) {
              margin-right: 0;
          }
          .sortInfo:hover {
              color: #EC212D;
              border-color: #EC212D;
          }
          .selectSort {
              background: #EC212D;
              border-color: #EC212D;
              color: #fff;
          }
          .selectSort:hover {
              color: #fff;
          }
      }
    .brankZone {
        display: flex;
        flex-wrap: wrap;
        height: 230px;
        margin: 15px 0 28px 0;
        .brankInfo {
            cursor: pointer;
            width: 236px;
            height: 110px;
            margin-right: 10px;
            margin-bottom: 10px;
            .brankName {
                position: relative;
                font-size: 32px;
                font-weight: bold;
                color: #333;
                background: #fff;
                height: 100%;
                text-align: center;
                line-height: 110px;
                img {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%,-50%);
                    max-height: 80%;
                    max-width: 80%;
                }
            }
        }
        .brankInfo:nth-child(5n+5) {
            margin-right: 0;
        }
    }
    .navBar {
      margin-top: 20px;

      .el-tabs__content {
        display: none;
      }

      .el-tabs__nav-wrap::after {
        background-color: transparent;
      }

      .el-tabs__item {
        font-size: 18px;
      }
    }
  }

  .poster img:hover {
    -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    -webkit-transform: translate3d(0, -2px, 0);
    transform: translate3d(0, -2px, 0);
  }
}
</style>
